import * as React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
const EventTypeLabel = ({ isAlert }) => {
  const { t } = useTranslation("events");
  return isAlert ? /* @__PURE__ */ React.createElement(Label, { bsStyle: "warning" }, t("alerts_types.alert")) : /* @__PURE__ */ React.createElement(Label, { bsStyle: "info" }, t("alerts_types.event"));
};
export default EventTypeLabel;
